import React, {useState, useEffect, useRef} from "react";
import PortableText from "./portableText";
import * as styles from './fourColumnTiles.module.css';
import { gsap, TweenMax, Expo } from "gsap";

function FourColumnTiles(props) {

    const sectionRef = useRef();
    const titleRef = useRef();

    useEffect(() => {
        
        let isInViewport = (ins, os) => {
            let offset = (os) ? os : 0;
            if(ins.offset()){
                let elementTop = ins.offset().top + 10 - offset;
                let elementBottom = elementTop + ins.outerHeight() - offset;
                let viewportTop = $(window).scrollTop();
                let viewportBottom = viewportTop + $(window).height();
                return elementBottom > viewportTop && elementTop < viewportBottom;
            }
            return false;
        }

        // TweenMax.set([titleRef.current], {
        //     opacity: 0,
        //     y: 80
        // });

        // TweenMax.set($(sectionRef.current).find('.stagger-item'), {
        //     opacity: 0,
        //     y: 80
        // });

        if(!$(sectionRef.current).hasClass('anim-complete')){
            $(window).on('scroll', () => {
                if(isInViewport($(sectionRef.current), (0-($(window).height()/4)) )){

                    // TweenMax.to(
                    //     titleRef.current, 
                    //     0.45, 
                    //     { 
                    //         opacity: 1, 
                    //         y: 0, 
                    //         delay : 0.25,
                    //         onComplete : () => {
                    //             $(sectionRef.current).addClass('anim-complete');
                    //         }
                    //     } 
                    // );

                    // TweenMax.staggerTo(
                    //     $(sectionRef.current).find('.stagger-item'),
                    //     0.45,
                    //     {
                    //         opacity: 1, 
                    //         y: 0,
                    //         delay : 0.55
                    //     },
                    //     0.25
                    // )
                    $(sectionRef.current).addClass('anim-complete');
                }
            });
        }

    });

    return (
        <div className={styles.sectionFourColumnTiles} ref={sectionRef}>
            <div className={styles.sectionContent}>
                <div className={styles.sectionContainer}>
                    <h3 className={styles.sectionHeading} ref={titleRef}>{props.label}</h3>
                    <div className={styles.sectionTiles}>
                        {
                            props.tiles.map((item, i) => {  

                                let itemClass = styles.tileItem+" stagger-item";

                                return (
                                    <div className={itemClass} key={i}>
                                        <div className={styles.tiImageWrap}>
                                            {
                                                (item.image) ?
                                                <img src={item.image.image.asset.url} alt={item.title} />
                                                : ``
                                            }
                                        </div>
                                        <div className={styles.tiContentWrap}>
                                            <h3>{item.heading}</h3>
                                            <PortableText blocks={item.desc} />
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>
                </div>
            </div>
        </div>
    );

}

export default FourColumnTiles;